module.exports = __webpack_public_path__ + "pinterest.dbe8f426f96921050dae69e01e2318df.png";